<template>
  <div class="ship-popup">
    <div class="cesium-popup-header flex justify-between align-center">
      <span>视频信息</span>
      <ElButton circle size="small" @click="props.close">X</ElButton>
    </div>
    <table v-if="properties">
      <tbody>
        <tr v-for="item in tableData" :key="item.key">
          <td class="text-green-800">{{ item.key }}</td>
          <td>{{ item.value }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import { ElButton } from 'element-plus'
import type { ICameraData } from '@/apiFzn/types'

const props = defineProps<{
  properties: object
  close(): void
}>()
const properties = computed(() => {
  return props.properties as ICameraData
})
const tableData = computed(() => {
  const res = [
    {
      key: '名称：',
      value: properties.value.name,
    },
    {
      key: '备注：',
      value: properties.value.description,
    },
  ]
  // const extendInfo = properties.value.extendInfo
  // if (extendInfo) {
  //   try {
  //     for (const [key, value] of Object.entries(JSON.parse(extendInfo))) {
  //       res.push({
  //         key,
  //         value,
  //       })
  //     }
  //   } catch (error) {
  //     console.error('extendInfo解析失败', error)
  //   }
  // }
  return res.filter((el) => el.value != undefined)
})
// 设备类型：1.AIS基站；2.对射激光;3.远距离激光；4.雷达；5.声光告警设备；6.水深设备；7.视频设备；
function maptoZh_equipmentType(type: number) {
  switch (type) {
    case 1:
      return 'AIS基站'
    case 2:
      return '对射激光'
    case 3:
      return '远距离激光'
    case 4:
      return '雷达'
    case 5:
      return '声光告警设备'
    case 6:
      return '水深设备'
    case 7:
      return '视频设备'
    default:
      return '未知：' + type
  }
}
// 设备状态：0.停用；1.正常；2.异常
function maptoZh_equipmentStatus(status: number) {
  switch (status) {
    case 0:
      return '停用'
    case 1:
      return '正常'
    case 2:
      return '异常'
    default:
      return '未知：' + status
  }
}
</script>
